/**
 * Created by sung on 2017-02-07.
 */
import {Component, OnInit, ViewChild } from '@angular/core';
import {NgModule} from '@angular/core';

import { DataTableModule, SharedModule,PaginatorModule,DropdownModule,InputTextModule,ChartModule,ButtonModule } from 'primeng/primeng';
import {MamAdminService} from '../../service/mam_service.component';

import {SearchModule} from "../../component/search.component";

import {FormsModule} from "@angular/forms";
import {HttpModule} from "@angular/http";
import {BrowserModule} from "@angular/platform-browser";

import {CommonModule} from "@angular/common";
import {Device} from "../../model/device";
import {UIChart} from "primeng/components/chart/chart";
import {OsStatus} from "../../model/os_status";
import {CompanyDropDownListModule} from "../../component/company-drop-down-list/company-drop-down-list.component";
import {UserGroupCheckTreeModule} from "../../component/user_checktree.component";
import {Logger, Options, Level } from "angular2-logger/core";
import {TranslatePipeMoudle} from "../../translate/translate.module.pipe";
import {TranslateServiceForm} from "../../translate/translate.service"; // ADD THIS


@Component({
  selector: 'install-location',
  templateUrl: 'installation_log.html'
})
export class InstallationLogComponent  implements  OnInit{

  @ViewChild("chart") chart: UIChart;
  @ViewChild("chart2") chart2: UIChart;
  @ViewChild("chart3") chart3: UIChart;

  os_status : OsStatus;
  private agent_status : any;
  DeviceConnectionStatus : any;
  DeviceLastVersionStatus : any;
  private dept_os_list : Device[] = [];
  private office_status : Device[] = [];
  

  chartData : any = {};
  lastVersionChartData : any;
  lastVersionChartOptions : any;
  connectionChartData : any;
  connectionChartOptions : any;
  options : any;

  table_list : any;
  officeTable : any;
  totalRecord : number;
  selectedCompany : any;
  selectedTargetLists : any;
  selectedTargetIdLists : any;
  groupList : any = [];
  translate : TranslateServiceForm;
  constructor(private service:MamAdminService, private logger : Logger, private _translate: TranslateServiceForm) {
      this.translate = _translate;
      this.chartData = {
        labels : ['android', 'ios', 'windows'],
        datasets: [
          {
            data : [0,0,0],
            backgroundColor: [
              "#FF6384",
              "#36A2EB",
              "#FFCE56"
            ],
            hoverBackgroundColor: [
              "#FF6384",
              "#36A2EB",
              "#FFCE56"
            ]
          },
        ]
      }
      this.options = {
        title: {
          display: true,
          text: this.translate.instant('LANG_Device_Os_Count'),
          fontSize: 13
        },
        legend: {
          position: 'top'
        },
        responsive : false
      };

      this.lastVersionChartData = {
        labels : [this.translate.instant('LANG_APP_OldVersion')+'(%)',this.translate.instant('LANG_APP_LastestVersion')+'(%)'],
        datasets: [
          {
            data : [0,0],
            backgroundColor: [
              'green',
              'orange'
            ],
            hoverBackgroundColor: [
              'green',
              'orange'
            ]
          },
        ]
      }
      this.lastVersionChartOptions = {
        title: {
          display: true,
          text: this.translate.instant('LANG_LastVersion_Status'),
          fontSize: 13
        },
        legend: {
          position: 'top'
        },
        responsive : false
      };
      this.connectionChartData = {
        labels : [this.translate.instant('LANG_Normal')+'(%)', this.translate.instant('LANG_network_bad')+'(%)'],
        datasets: [
          {
            data : [0,0],
            backgroundColor: [
              "blue",
              "red"
            ],
            hoverBackgroundColor: [
              "blue",
              "red"

            ]
          },
        ]
      }
      this.connectionChartOptions = {
        title: {
          display: true,
          text: this.translate.instant('LANG_Connection_Status'),
          fontSize: 13
        },
        legend: {
          position: 'top'
        },
        responsive : false
      };

  }
  ngOnInit() {
    //this.getDeviceOsStatus();

    //this.getDeptDeviceOs();
    //this.getDeviceStatus();
    //this.getOfficeStatistic(1,999);
    //this.getAgentInstallData();
  }


  updateChart(chart: UIChart) {
    if(chart.type == "pie"){
      this.getDeviceOsStatus(this.selectedCompany.id);
    }else if(chart.type == "doughnut"){
      this.getDeviceConnectionStatus(this.selectedCompany.id);
      this.getDeviceLastVersionStatus(this.selectedCompany.id);
    }
  }
  updateDeptDeviceOs(){
    this.getAttDeviceTypeStatus(this.selectedCompany.id,this.selectedTargetIdLists);
  }
  updateGetOfficeStatistic(){
    this.getOfficeStatistic(this.selectedCompany.id,1,999);
  }
  excelExport(event){
    //작업..
    this.logger.debug("엑셀 출력");
  }

  onSelectedCompany(company) {
    this.selectedCompany = company;
    this.getDeviceOsStatus(this.selectedCompany.id);
    this.getDeviceConnectionStatus(this.selectedCompany.id);
    this.getDeviceLastVersionStatus(this.selectedCompany.id);
    this.getOfficeStatistic(this.selectedCompany.id,1,999);
    this.groupList = [];
    this.logger.debug("combo - select :" , this.selectedCompany);
  }

  selectedTrees(event){
      this.logger.debug("selectedTree : ",event);
      this.selectedTargetLists = event;

      let list :any = [];
      if(this.selectedTargetLists && this.selectedTargetLists.length > 0){
          this.selectedTargetLists.forEach(item => {
              list.push(Number(item.id));
          });
      }
      this.selectedTargetIdLists = list;
      this.getAttDeviceTypeStatus(this.selectedCompany.id,list);
  }

  /*paginate(event) {
    this.logger.debug(event);
    this.getOfficeStatistic(event.page + 1, event.rows);
  }*/

  // 단말기 OS 현황
  getDeviceOsStatus(companyId : any) {
    this.service.getDeviceOsStatus(companyId).subscribe(
        value => {
            this.os_status = value;
            this.logger.debug("1-- os_statsu_data : " , value);
            this.logger.debug("1-- os_statsu_data : " , this.os_status);
        },
        error=>{
            this.logger.error("-- error : " + error);
        },
        ()=>{
            this.logger.info("-- complate : ");
            this.chart.data.datasets[0].data[0] = this.os_status.android;
            this.chart.data.datasets[0].data[1] = this.os_status.ios;
            this.chart.data.datasets[0].data[2] = this.os_status.windows;
            this.chart.refresh();


        }
    );
  }

  /*// 조직별 단말현황
  getDeptDeviceOs(){
    this.service.getDeptDeviceOs().subscribe(
      value => {
        this.table_list = value;
        let androidCount = 0;
        let iosCount = 0;
        let windowsCount = 0;
        let totalCount = 0;
        for(let item of this.table_list){
          androidCount += item.android;
          iosCount += item.ios;
          windowsCount += item.windows;
          totalCount += item.total;

        }
        let totalTemp : any = {
          'android' : androidCount,
          'ios' : iosCount,
          'windows' : windowsCount,
          'total' : totalCount,
          'name' : '전체'
        }
        this.table_list.push(totalTemp);

        this.logger.debug("1-- dept_os_list : " , value);

      },
      error=>{
        this.logger.error("-- error : " + error);
      },
      ()=>{
        this.logger.info("-- complate : ");

      }
    )
  }*/
  // 조직별 단말현황
  getAttDeviceTypeStatus(companyId:any,list:any){
    this.service.getAttDeviceTypeStatus(companyId,list).subscribe(
      value => {
        this.table_list = value;
        this.logger.debug("1-- dept_os_list : " , value);

      },
      error=>{
        this.logger.error("-- error : " + error);
      },
      ()=>{
        this.logger.info("-- complate : ");

      }
    )
  }




  // 연결상태
  getDeviceConnectionStatus(companyId:any){
    this.service.getDeviceConnectionStatus(companyId).subscribe(
        value => {
            //this.agent_status = value;
            this.DeviceConnectionStatus = value;
            this.logger.debug("--- DeviceConnectionStatus : " , value);
        },
        error=>{
            this.logger.error("-- error : " + error);
        },
        ()=>{
            this.logger.info("-- complate : ");
            this.chart3.data.datasets[0].data[0] = Math.floor(this.DeviceConnectionStatus.normal*100/(this.DeviceConnectionStatus.abnormal+this.DeviceConnectionStatus.normal));
            this.chart3.data.datasets[0].data[1] = 100-Math.floor(this.DeviceConnectionStatus.normal*100/(this.DeviceConnectionStatus.abnormal+this.DeviceConnectionStatus.normal));

            this.chart3.refresh();
        }
    )

  }

  // 업무앱 설치현황
  getOfficeStatistic(companyId:any, page:number, max:number){
    this.service.getOfficeStatistic(companyId, page, max).subscribe(
      value => {
        /*this.logger.debug(page,max)*/
        this.officeTable = value;
        this.totalRecord = value.length;
        this.logger.debug("1-- office_status : " , value);
      },
      error=>{
        this.logger.error("-- error : " + error);
      },
      ()=>{
        this.logger.info("-- complate : ");
      }
    )
  }

  // 최신 버전 설치 현황
  getDeviceLastVersionStatus(companyId :number){
      this.service.getDeviceLastVersionStatus(companyId).subscribe(
          value => {
              this.DeviceLastVersionStatus = value;
              this.logger.debug("1-- DeviceLastVersionStatus : " , value);
          },
          error=>{
              this.logger.error("-- error : " + error);
          },
          ()=>{
              this.logger.info("-- complate : ");
              this.chart2.data.datasets[0].data[0] = 100-Math.floor(this.DeviceLastVersionStatus.abnormal*100/(this.DeviceLastVersionStatus.abnormal+this.DeviceLastVersionStatus.normal));
              this.chart2.data.datasets[0].data[1] = Math.floor(this.DeviceLastVersionStatus.abnormal*100/(this.DeviceLastVersionStatus.abnormal+this.DeviceLastVersionStatus.normal));

              this.chart2.refresh();

          }
      )
  }

}


@NgModule({
  imports: [DataTableModule, SharedModule, CommonModule,PaginatorModule,DropdownModule,InputTextModule,BrowserModule,HttpModule,FormsModule,SearchModule,ChartModule,ButtonModule,CompanyDropDownListModule,UserGroupCheckTreeModule, TranslatePipeMoudle],
  exports: [InstallationLogComponent],
  declarations: [InstallationLogComponent],
  providers: [MamAdminService],
})
export class InstallationLogModule {
}



// WEBPACK FOOTER //
// ./src/app/page/log/installation_log.ts